import '../styles/SkeletonLoader.css'

/**
 * SkeletonLoader Component
 * Shows animated placeholder while content is loading
 *
 * @param {Object} props
 * @param {number} props.rows - Number of skeleton rows to show (default: 5)
 * @param {number} props.columns - Number of columns per row (default: 4)
 * @param {string} props.type - Type of skeleton: 'table', 'card', 'list' (default: 'table')
 */
const SkeletonLoader = ({ rows = 5, columns = 4, type = 'table' }) => {
  if (type === 'card') {
    return (
      <div className="skeleton-card-container">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="skeleton-card">
            <div className="skeleton-card-header skeleton-animate" />
            <div className="skeleton-card-body">
              <div className="skeleton-line skeleton-animate" style={{ width: '80%' }} />
              <div className="skeleton-line skeleton-animate" style={{ width: '60%' }} />
              <div className="skeleton-line skeleton-animate" style={{ width: '90%' }} />
            </div>
          </div>
        ))}
      </div>
    )
  }

  if (type === 'list') {
    return (
      <div className="skeleton-list-container">
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <div key={rowIndex} className="skeleton-list-item">
            <div className="skeleton-avatar skeleton-animate" />
            <div className="skeleton-list-content">
              <div className="skeleton-line skeleton-animate" style={{ width: '70%' }} />
              <div className="skeleton-line skeleton-animate" style={{ width: '50%', height: '14px' }} />
            </div>
          </div>
        ))}
      </div>
    )
  }

  // Default: table type
  return (
    <div className="skeleton-table-container">
      {/* Header Row */}
      <div className="skeleton-table-header">
        {Array.from({ length: columns }).map((_, colIndex) => (
          <div key={colIndex} className="skeleton-header-cell skeleton-animate" />
        ))}
      </div>

      {/* Data Rows */}
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className="skeleton-table-row">
          {Array.from({ length: columns }).map((_, colIndex) => (
            <div
              key={colIndex}
              className="skeleton-table-cell skeleton-animate"
              style={{
                width: colIndex === 0 ? '30%' : colIndex === columns - 1 ? '15%' : '20%'
              }}
            />
          ))}
        </div>
      ))}
    </div>
  )
}

export default SkeletonLoader
